import React from 'react';
import logo from '../images/glometal-logo.PNG';

const Vision = () => (
    <div className='highlight'>
        <img src={logo} alt="Glometal logo" className='logo' />
        <h1>Our Vision</h1>
        <p className='highlight-text'>We aim to be the leading service provider, offering unmatched support and supply solutions for engineering needs, while promoting innovation, reliability, and excellence in all we do.</p>
    </div>
);

export default Vision;